module.exports = __webpack_public_path__ + "img/C925.275b5400.jpg";